import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { DataFilterAction, DataFilterManagerService, OptionState } from '@anecdotes/design-system/data-manipulation';
import { map, switchMap, take } from 'rxjs/operators';
import { UserEventService } from '@anecdotes/user-event-core';
import { UserEvents, FilterEvents } from '@anecdotes/user-event-data-access';

@Injectable()
export class FilterEventTrackingEffects {
  constructor(
    private actions$: Actions,
    private userEventService: UserEventService,
    private filterManager: DataFilterManagerService
  ) {}

  toggleFilterOption$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(DataFilterAction.toggleOptions, DataFilterAction.selectOptions),
        switchMap((action) => {
          const { instanceId, optionsData, fieldName } = action;
          const fieldId: string = Object.keys(optionsData)[0];
          const field: string = fieldName ?? fieldId;
          const category: string = Object.values(optionsData).flat()[0];

          return this.filterManager.getFieldRelatedActiveOptions(instanceId, fieldId).pipe(
            map((checkedOptions: OptionState[]) => [category, field, checkedOptions]),
            take(1)
          );
        }),
        map(([category, fieldName, options]: [string, string, OptionState[]]) => {
          const shouldSendEvent = options.some((option) => option.id === category);

          if (shouldSendEvent) {
            this.sendEvent(category, fieldName);
          }
        })
      ),
    { dispatch: false }
  );

  private sendEvent(category: string, fieldName: string): void {
    this.userEventService.sendEvent(UserEvents.GENERAL_FILTER, {
      [FilterEvents.PAGE_URL]: location.pathname,
      [FilterEvents.FILTER_CATEGORY]: fieldName,
      [FilterEvents.FILTER_SELECTED]: category,
    });
  }
}
